/**
 * Converts the refresh-token expiration returned by the authentication API
 * into the millisecond timestamp expected by browser timers.
 *
 * The documented contract uses Unix seconds. Milliseconds are also accepted
 * defensively to avoid multiplying an already-normalized timestamp.
 */
export function getRefreshExpiry(
  refreshTokenExpiresAt: number | null | undefined,
): number | null {
  if (
    !refreshTokenExpiresAt ||
    !Number.isFinite(refreshTokenExpiresAt) ||
    refreshTokenExpiresAt < 0
  ) {
    return null
  }

  const expiresAt =
    refreshTokenExpiresAt < 1_000_000_000_000
      ? refreshTokenExpiresAt * 1000
      : refreshTokenExpiresAt

  return expiresAt
}
